import { z } from 'zod';
import { CustomerStatus } from '../../constants/customer-status.js';
import { newContactsInputSchema } from '../contact/new-contacts-input.js';
import { createCustomerAddressPairInputSchema } from '../customer-address/create-address-pair-input.js';
import { createCustomerLicenseInputSchema } from '../customer-license/create-input.js';
import { nonNegativeNumber, optionalTrimmedNullableEmail, optionalTrimmedNullableString, optionalUuidString, rejectPhoneContextInjection, } from '../zod-helpers/index.js';
import { CUSTOMER_CONSTRAINTS } from './constraints.js';
import { customerBrandIdsSchema } from './customer-brand-ids.js';
import { checkCustomerIdentity } from './rules.js';
export const createCustomerInputSchema = z
    .object({
    name: z.string().trim().max(CUSTOMER_CONSTRAINTS.name.maxLength),
    url: z.string().max(CUSTOMER_CONSTRAINTS.url.maxLength).optional().nullable(),
    note: optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.note.maxLength),
    email: optionalTrimmedNullableEmail(CUSTOMER_CONSTRAINTS.email.maxLength, `Invalid ${CUSTOMER_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.phone.maxLength)),
    currencyId: optionalUuidString('Invalid currency selection.').optional().nullable(),
    paymentTermsId: optionalUuidString('Invalid payment terms selection.').optional().nullable(),
    shipTermsId: optionalUuidString('Invalid ship terms selection.').optional().nullable(),
    number: optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.number.maxLength),
    deliveryPreferences: optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.deliveryPreferences.maxLength),
    brandIds: customerBrandIdsSchema,
    license: createCustomerLicenseInputSchema.optional().nullable(),
    address: createCustomerAddressPairInputSchema.optional().nullable(),
    contacts: newContactsInputSchema.optional().nullable(),
    creditLimit: nonNegativeNumber(CUSTOMER_CONSTRAINTS.creditLimit.label).optional().nullable(),
    taxExempt: z.boolean().optional().nullable(),
    taxExemptNumber: z
        .string()
        .max(CUSTOMER_CONSTRAINTS.taxExemptNumber.maxLength)
        .optional()
        .nullable(),
    taxRateId: optionalUuidString('Invalid tax rate selection.').optional().nullable(),
    statusId: z.enum(CustomerStatus, 'Invalid customer status.').optional().nullable(),
})
    .superRefine((input, context) => {
    for (const issue of checkCustomerIdentity(input)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-input.js.map